import axios from 'axios';
import { getToken } from '../utils/tokenUtils';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export const authHeader = () => ({
    headers: { Authorization: `Bearer ${getToken()}` }
});

export const register = (data) => axios.post(`${BASE_URL}/api/auth/register`, data);
export const login = (data) => axios.post(`${BASE_URL}/api/auth/login`, data);
export const getMyInfo = () => axios.get(`${BASE_URL}/api/user/me`, authHeader());